export default __webpack_public_path__ + "static/media/all-eyes-on-me-465.69b53c30.mp3";